import util from '@/libs/util'

const post = util.ajax.post

export const homeIndexUrls = [
  // 查询门店信息
  '/homeindex/liststore',
  // 查询设备信息
  '/tailgasdevice/list',
  // 激活设备
  '/tailgasdevice/active'
]

export const homeIndex = {}

homeIndex.listStore = function (params) {
  return post('/homepage/devicelistbystoreid', params)
}
homeIndex.activeDevice = function (params) {
  return post('/tailgasdevice/active', params)
}
homeIndex.pay = function (params) {
  return post('/pay/save', params)
}
homeIndex.payStatus = function (params) {
  // return post('/pay/payStatus?paymentId=' + params)
  return post('/pay/payStatus', params)
}
homeIndex.payPrice = function (params) {
  return post('/cooperate/device/chargingPrice', params);
}

// 新版首页api
homeIndex.todayOrder = function (params) {
  return post('/homepage/getTodayOrderOverview', params)
}
homeIndex.dataCount = function (params) {
  return post('/homepage/getIndicatorStatistics', params)
}
homeIndex.orderTrend = function (params) {
  return post('/homepage/getOrderTrend', params)
}
homeIndex.orgTree = function () {
  return post('/organ/getOrgTree')
}



// WEBPACK FOOTER //
// ./src/api/gip/home/homeindex.js